import { useEffect, useRef, useState } from 'react'
import { ShieldX, X } from 'lucide-react'
import { onUnauthorized } from '../store/alerts'

const DISMISS_AFTER = 6

interface Alert {
  id: number
  resource: string
  remaining: number
}

export function UnauthorizedAlert() {
  const [alerts, setAlerts] = useState<Alert[]>([])
  const counterRef = useRef(0)

  useEffect(() => {
    return onUnauthorized((resource) => {
      const id = ++counterRef.current
      setAlerts((prev) => [...prev, { id, resource, remaining: DISMISS_AFTER }])
    })
  }, [])

  useEffect(() => {
    if (alerts.length === 0) return
    const tick = setInterval(() => {
      setAlerts((prev) =>
        prev
          .map((a) => ({ ...a, remaining: a.remaining - 1 }))
          .filter((a) => a.remaining > 0)
      )
    }, 1000)
    return () => clearInterval(tick)
  }, [alerts.length > 0])

  const dismiss = (id: number) => setAlerts((prev) => prev.filter((a) => a.id !== id))

  if (alerts.length === 0) return null

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-2 max-w-xs w-full">
      {alerts.map((alert) => (
        <div key={alert.id}
          className="flex items-start gap-3 bg-white border border-paper-border rounded-lg shadow-dropdown px-4 py-3 overflow-hidden">
          <div className="w-7 h-7 rounded-md bg-red-50 flex items-center justify-center shrink-0">
            <ShieldX size={14} className="text-red-500" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-ink">Access denied</p>
            <p className="text-xs text-ink-dim mt-0.5">
              You don't have access to{' '}
              <span className="font-medium text-ink">{alert.resource}</span>.
            </p>
            <div className="mt-2 h-0.5 rounded-full bg-paper-border overflow-hidden">
              <div
                className="h-full bg-red-400 rounded-full transition-all duration-1000 ease-linear"
                style={{ width: `${(alert.remaining / DISMISS_AFTER) * 100}%` }}
              />
            </div>
          </div>
          <button onClick={() => dismiss(alert.id)}
            className="text-ink-dim/60 hover:text-ink-dim transition-colors shrink-0 mt-0.5">
            <X size={13} />
          </button>
        </div>
      ))}
    </div>
  )
}
